/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ValidationError,
    ValidationErrorFromJSON,
    ValidationErrorFromJSONTyped,
    ValidationErrorToJSON,
} from './';

/**
 * 
 * @export
 * @interface ValidationErrors
 */
export interface ValidationErrors {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof ValidationErrors
     */
    errors?: Array<ValidationError> | null;
}

export function ValidationErrorsFromJSON(json: any): ValidationErrors {
    return ValidationErrorsFromJSONTyped(json, false);
}

export function ValidationErrorsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidationErrors {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'errors': !exists(json, 'errors') ? undefined : (json['errors'] === null ? null : (json['errors'] as Array<any>).map(ValidationErrorFromJSON)),
    };
}

export function ValidationErrorsToJSON(value?: ValidationErrors | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'errors': value.errors === undefined ? undefined : (value.errors === null ? null : (value.errors as Array<any>).map(ValidationErrorToJSON)),
    };
}


